import React, { useEffect, useState } from "react";
import { getData } from "../../services/Axios/Axios";
import { ApiUrl } from "../../config/apiConfig";
import { confirmAction } from "../../utils/utils";
import { permissionGroups } from "../../pages/settings/permissionsConfig";
import { permissionGroupsTMS } from "../../config/constant";

interface PermissionsGridProps {
  permissions: string[]; // e.g. formData.permissions
  setPermissions: (updated: string[]) => void; // a callback to update permissions
  defaultPermissions: string[];
}

const PermissionsGrid: React.FC<PermissionsGridProps> = ({
  permissions,
  setPermissions,
  defaultPermissions,
}) => {
  const toggleGroup = (name: string) => {
    setPermissions(
      permissions.includes(name)
        ? permissions.filter((p) => p !== name)
        : [...permissions, name],
    );
  };

  const [users, setAllUsers] = useState<
    {
      _id: string;
      name: string;
      email: string;
      phoneNumber: string;
      password: string;
      permissions: never[];
      adminType: string;
    }[]
  >([]);

  const getAllUsers = async () => {
    const response = await getData(ApiUrl.listAdmins, {});
    setAllUsers(response.data);
  };

  useEffect(() => {
    getAllUsers();
  }, []);
  console.log(permissions);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 px-3">
      {permissionGroupsTMS.map((group) => (
        <>
          <div
            key={group.name}
            className="border rounded-xl shadow-sm p-4 bg-white"
          >
            <label className="flex items-center space-x-2 mb-2">
              <input
                type="checkbox"
                className="h-4 w-4 text-blue-600 rounded accent-greenBg"
                checked={permissions.includes(group.name)}
                onChange={() =>
                  confirmAction(
                    `Are you sure you want to ${
                      permissions.includes(group.name) ? "remove" : "give"
                    } access`,
                    () => toggleGroup(group.name),
                  )
                }
              />
              <span className="font-bold">{group.name}</span>
            </label>
            <ul className="pl-6 text-gray-700 text-sm space-y-1">
              {group.subPermissions.map((sub) => (
                <div className="flex items-center" key={sub}>
                  <p className="pl-2">{sub}</p>
                </div>
              ))}
            </ul>
          </div>
        </>
      ))}
    </div>
  );
};

export default PermissionsGrid;
